import { render, staticRenderFns } from "./AdvisorsTable.vue?vue&type=template&id=2f5e84bc&"
import script from "./AdvisorsTable.vue?vue&type=script&lang=js&"
export * from "./AdvisorsTable.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorsTable.vue?vue&type=style&index=0&id=2f5e84bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports